import React, { useState } from "react";
import styled from "styled-components";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OrganizationIcon } from "../../assets/images/OrganizationIcon";
import { InvitationIcon } from "../../assets/images/InvitationIcon";
import { media } from "../../styles/mixins";
import { Log } from "../../assets/images/Log";
import { Experiment } from "../../assets/images/Experiment";
import { BlockTestIcon } from "../../assets/images/BlockTestIcon";
export const Navbar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);

  const navItems = [
    // {
    //   path: "/",
    //   label: t("dashboard.dashboard"),
    // icon: <HomeIcon />,
    // },
    {
      path: "/invitations",
      label: t("invitations.invitations"),
      icon: <InvitationIcon />,
    },
    {
      path: "/organizations",
      label: t("organizations.organizations"),
      icon: <OrganizationIcon />,
    },
    {
      path: "/logs",
      label: t("logs.logs"),
      icon: <Log />,
    },
    {
      path: "/test",
      label: t("test.testPage"),
      icon: <Experiment />,
    },
    {
      path: "/block-test",
      label: t("test.blockTestPage"),
      icon: <BlockTestIcon />,
    },
  ];

  return (
    <NavbarContainer>
      <GlassPanel
        $isExpanded={isExpanded}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        <NavList>
          {navItems.map((item) => (
            <NavItem key={item.path} isActive={location.pathname === item.path}>
              <StyledNavLink
                to={item.path}
                $isActive={location.pathname === item.path}
              >
                <IconWrapper>{item.icon}</IconWrapper>
                {isExpanded && <NavText>{item.label}</NavText>}
              </StyledNavLink>
            </NavItem>
          ))}
        </NavList>
      </GlassPanel>
    </NavbarContainer>
  );
};

const NavbarContainer = styled.nav`
  position: fixed;
  top: 6rem;
  left: 20px;
  bottom: 20px;
  height: 100%;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const GlassPanel = styled.div`
  width: ${(props) => (props.$isExpanded ? "240px" : "5.56vw")};
  max-width: ${(props) => (props.$isExpanded ? "240px" : "80px")};
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  padding: 1.5rem 0;
  overflow: hidden;
  display: flex;
  justify-content: ${(props) => (props.$isExpanded ? "flex-start" : "center")};

  transition: all 0.3s ease;
`;

const NavList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;

const NavItem = styled.li`
  margin: 0.25rem 0.75rem;
  position: relative;
  border-radius: 0.75rem;
  background-color: ${({ isActive }) =>
    isActive ? "rgba(79, 70, 229, 0.1)" : "transparent"};
  transition: background-color 0.2s;

  &:hover {
    ${({ $isActive }) =>
      !$isActive && "background-color: rgba(79, 70, 229, 0.05);"}
  }
`;

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: ${({ $isActive }) => ($isActive ? "#4F46E5" : "#64748b")};
  font-weight: 500;
  padding: 0.75rem 0.5vw;
  display: flex;
  align-items: center;
  transition: color 0.2s;
  white-space: nowrap;

  &:hover {
    ${({ $isActive }) => !$isActive && "color: #4f46e5;"}
  }

  ${media.laptop(`
    padding: 0.75rem 1rem;
  `)}
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

const NavText = styled.span`
  margin-left: 12px;
  font-size: 0.875rem;
  opacity: 1;
  transition: opacity 0.3s ease;
`;
